import { useAsyncFn } from 'react-use';

import { sendPasswordResetEmail } from 'supertokens-auth-react/recipe/thirdpartyemailpassword';

import { IForgotPasswordRequest } from '../../types/custom-dto.type';

export const useForgotPassword = () => {
  return useAsyncFn(async (req: IForgotPasswordRequest) => {
    const response = await sendPasswordResetEmail({
      formFields: Object.entries(req).map(([id, value]) => ({
        id,
        value,
      })),
    });
    if (response?.status === 'OK') {
      return true;
    } else if (response.status === 'FIELD_ERROR' && response.formFields) {
      throw new Error(response.formFields[0].error);
    }
  });
};
